




















import { computed, defineComponent, PropType } from "@vue/composition-api";

export interface Props {
  iconName: string;
  type: String;
  mainTextList: string[];
  visible: Boolean;
}

export default defineComponent({
  name: "OccAlert",
  props: {
    iconName: {
      type: String,
      default: ""
    },
    type: {
      type: String as PropType<"success" | "warning" | "danger">,
      default: "danger",
      validator: function(value: string) {
        return ["success", "warning", "danger"].includes(value);
      }
    },
    mainTextList: {
      type: Array as PropType<string[]>,
      default: ""
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  setup(props: Props) {
    const occAlertClass = computed(() => {
      return [
        `occ-alertFloating--${props.type}`,
        props.visible ? "occ-alertFloating--visible" : ""
      ];
    });

    return { occAlertClass };
  }
});
